// This file is automatically generated. Do not edit manually.

import { Delivery } from "src/api/generated/erp/db/types/tables/delivery";
import { DeliveryView } from "src/api/generated/erp/db/types/tables/deliveryView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryEditApiForCargoDriver {
	export async function getFormInitData(args: {
		deliveryId: number;
	}): Promise<DeliveryEditApiForCargoDriver_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/cargoDriverApi/edit/getFormInitData",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as DeliveryEditApiForCargoDriver_FormInitData;
	}

	export async function update(args: { delivery: Delivery }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/cargoDriverApi/edit/update",
			method: "POST",
			data: {
				delivery: args.delivery,
			},
		});
		return response as void;
	}
}

export interface DeliveryEditApiForCargoDriver_FormInitData {
	delivery: DeliveryView;
}
